<div class="content">
  <div class="images">
    <img
      class="img1"
      src="/images/home/style1.webp"
      appSlideRight
      [slideRightDelay]="0"
      [onIntersection]="true"
    />
    <img class="img2" src="/images/home/style2.webp" />
  </div>
  <div class="text">
    <h2 appSlideRight [slideRightDelay]="0" [onIntersection]="true">
      Everyday Style, Full of Life
    </h2>
    <p appSlideRight [slideRightDelay]="100" [onIntersection]="true">
      {{appname}} celebrates young, vibrant fashion made for real life —
      effortless, modern pieces that help every woman feel confident, joyful,
      and ready to live beautifully.
    </p>
    <a
      matButton="filled"
      routerLink="/about-us"
      appSlideRight
      [slideRightDelay]="200"
      [onIntersection]="true"
      >Read More</a
    >
  </div>
</div>
